import request from '@/utils/request'

export function articleList(params) {
  return request({
    url: '/wx4agency_api/wechatapp/articleList',
    params,
    method: 'get'
  })
}
export function articleDetail(params) {
  return request({
    url: '/wx4agency_api/wechatapp/articleDetail',
    params,
    method: 'get'
  })
}
